var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-modal',{ref:"modal",attrs:{"title":"削除","size":"sm","ok-variant":"danger","ok-title":"削除","cancel-title":"キャンセル","centered":""},on:{"ok":function($event){return _vm.$emit('ok')}}},[_vm._v("\n  "+_vm._s(_vm.content)+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }